import {
  Cable,
  Home,
  Key,
  LayoutDashboard,
  Logs,
  Pyramid,
  Send,
  Settings,
  Sparkles,
  SquareLibrary,
  Store,
} from 'lucide-react'

import type { KratosUser } from '@/hooks/use-auth-user'

export type SidebarNavItem = {
  title: string
  url: string
  icon?: any
  hasSeparator?: boolean
  hasSubmenu?: boolean
  disabled?: boolean
  badgeLabel?: string
  badgeTone?: 'pink' | 'blue' | 'yellow' | 'gray'
  /** Feature keys that ALL must be accessible for this item to show. */
  requiredFeatures?: string[]
}

export const user = (authUser: KratosUser | null) => {
  const pictureSrc =
    typeof authUser?.traits?.picture === 'string' ? authUser.traits.picture.trim() : ''
  return {
    name: authUser
      ? authUser?.traits?.name
        ? `${authUser.traits.name.first} ${authUser.traits.name.last}`
        : String(authUser?.traits?.email || '')
            .trim()
            .split('@')[0] || 'User'
      : 'Fastfold',
    email: authUser?.traits?.email || 'Guest',
    avatar: pictureSrc || undefined
  }
}

export const navAura: SidebarNavItem[] = []

export const navMain: SidebarNavItem[] = [
  {
    title: 'Home',
    url: '/',
    icon: Home,
  },
  {
    title: 'New Agent',
    url: '/agents/home',
    icon: Send,
    hasSeparator: true,
    requiredFeatures: ['cloud_agent_ide_v2'],
  },
  {
    title: 'Apps',
    url: '/apps',
    icon: Store,
  },
  {
    title: 'Skills',
    url: '/agent/skills',
    icon: Sparkles,
  },
  {
    title: 'Jobs',
    url: '/jobs',
    icon: Logs,
    hasSeparator: true,
  },
  {
    title: 'Agents',
    url: '/agent/profiles',
    icon: Pyramid,
    hasSubmenu: true,
    requiredFeatures: ['agent_profiles'],
  },
  {
    title: 'Projects',
    url: '/projects',
    icon: LayoutDashboard,
    requiredFeatures: ['projects'],
  },
  {
    title: 'Library',
    url: '/library',
    icon: SquareLibrary,
    hasSeparator: true
  },
  {
    title: 'Integrations',
    url: '/integrations',
    icon: Cable
  },
  {
    title: 'API Keys',
    url: '/api-keys',
    icon: Key
  },
  {
    title: 'Settings',
    url: '/settings',
    icon: Settings,
    hasSubmenu: true
  },
]

export const navSecondary = [
  // Moved to the user menu (NavUser)
]

export const data = {
  user,
  navAura,
  navMain,
  navSecondary
}
